import { circlePrompts } from './circles.ts';

/** Spanish volume prompts (ADR 0095 §3, §5). */
export const volumePrompts = {
    countCubes: () => `¿Cuántos cubos unitarios llenan esta caja?`,
    edgeLengths: () => `¿Cuál es el volumen?`,
    twoBoxes: () => `¿Cuál es el volumen de este cuerpo?`,
    surfaceAreaNet: () => `Esta red se dobla para formar una caja. ¿Cuál es su área total?`,
    surfaceAreaBox: () => `¿Cuál es el área total de esta caja?`,
    missingEdge: (volume: string) => `El volumen es ${volume}. ¿Cuánto mide la arista que falta?`,
    /** ADR 0140 §4: the solid is named, and the pi sentence is Circles'. */
    cylinder: () => `¿Cuál es el volumen del cilindro? ${circlePrompts.piSentence()}`,
    cone: () => `¿Cuál es el volumen del cono? ${circlePrompts.piSentence()}`,
    sphere: () => `¿Cuál es el volumen de la esfera? ${circlePrompts.piSentence()}`,
    /** A number of hundredths as the sheet writes it: a point. */
    decimal: circlePrompts.decimal,
    cubes: (count: number) => `${count} cubos`,
};
